import * as React from "react";
import { gql, useMutation, MutationHookOptions, MutationTuple } from "@apollo/client";
import {
  OtpValidateMutationMutation,
  OtpValidateMutationMutationVariables
} from "../../../../schemaTypes";

export const otpValidateMutation = gql`
  mutation OTPValidateMutation(
    $verificationCode: String!
    $email: String!
  ) {
    otpValidate(
      verificationCode: $verificationCode
      email: $email
    ){
      errors{
        path
        message
      }
      message
    }
  }
`;

export interface WithOTPValidate {
  otpValidate: MutationTuple<OtpValidateMutationMutation, OtpValidateMutationMutationVariables>[0];
  loading: boolean;
  error?: Error;
}

interface Props {
  children: (data: WithOTPValidate) => React.ReactElement | null;
  options?: MutationHookOptions<OtpValidateMutationMutation, OtpValidateMutationMutationVariables>;
}

export const OTPValidate: React.FC<Props> = ({ children, options }) => {
  const [otpValidate, { loading, error }] = useMutation<
    OtpValidateMutationMutation, 
    OtpValidateMutationMutationVariables
  >(
    otpValidateMutation,
    options
  );

  return children({ otpValidate, loading, error });
};